import ACO from '../images/emblems/aco.png';

export const Aco = () => <div>

    <div>
        <img src={ACO} alt="ACO認定オーガニック" />
    </div>
    <span>この商品はACOに認定しています</span>
    <h3>ACO認定オーガニック<br />（無農薬有機栽培）</h3>

    ACO認定オーガニックとは
    ACO（Australia Certified Organic ）
    はオーストラリア最大の認定オーガニック機関です。世界でも信頼性が高く、また世界で1番厳しいオーガニック認定を行っている機関になります。オーストラリアや欧米も人気ですが、有機JAS とも相互認定された為、ここ数年日本でも注目を集めています。

    <ul>
        <li>合成化学物質</li>
        <li>人工着色料</li>
        <li>人工香料</li>
        <li>合成防腐剤</li>
        <li>合成界面活性剤</li>
        <li>人工調味料</li>
        <li>石油化学薬品</li>
        <li>化学肥料</li>
        <li>農薬</li>
    </ul>

    一切使用していない100%天然オーガニックになります。

</div>;
